module.exports = __webpack_public_path__ + "entry-150bfe9b/bdo-photo-0db2b2caeeeddcca76b93783e4f0bacc.webp";